<template>
  <card-item card="item_order" :tabs="tabs" :activeTab="activeTab" :id="id">
  
  </card-item>
</template>
<script>
export default {
  methods: {
  },
  props: ["id"],
  data() {
    return {
      tabs: [
        {
          title: "Информация",
          component: () => import("./Info"),
        },
        // {
        //   title: "Товары",
        //   component: () => import("./Purchases"),
        // },
        {
          title: "История статусов",
          component: () => import("./Statuses"),
        },
      ],
      activeTab: 0,
    };
  },
};
</script>